<template>
    <v-container>
        <v-row>
            <v-col class="d-flex">
                <bnft-near-wallet-button :contractId="VUE_APP_NEAR_WISHLIST_CONTRACT_ID" v-model="wallet" class="mr-2"></bnft-near-wallet-button>
                <v-btn v-if="wallet && wallet.isSignedIn()" small outlined @click="get({ forceUpdate: true })">Update</v-btn>
            </v-col>
        </v-row>
        <v-row v-for="(value, key) in wishlistData" :key="`${key}`">
            <v-col cols="2">
                <v-subheader inset>{{ key }}</v-subheader>
            </v-col>
            <v-col :cols="`${key}`.match(/giver_ids|wishlist_ids/) ? 4 : ''">
                <v-container>
                    <v-select v-if="`${key}`.match(/giver_ids|wishlist_ids/)" read-only persistent-hint :hint="key" :items="value" :suffix="`total: ${value.length}`"></v-select>
                    <v-expansion-panels v-else-if="`${key}`.match(/wishlist_givers_per_item|wishlist_item_balance_per_item|itemids_and_msrps|paid_gifts/)" v-model="panels[key]" flat multiple>
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                total: {{ value.length }}
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-data-table v-if="key === 'wishlist_givers_per_item'" :headers="headers['wishlist_givers_per_item']" :items="value.length && value.map(v => ({ uniqueItemId: v[0], giver: v[1] }))" dense>
                                    <template v-slot:[`item.uniqueItemId`]="{ item }">
                                        {{ item.uniqueItemId }}
                                    </template>
                                </v-data-table>
                                <v-data-table v-else-if="key === 'wishlist_item_balance_per_item'" :headers="headers['wishlist_item_balance_per_item']" :items="value.length && value.map(v => ({ uniqueItemId: v[0], balance: v[1] }))" dense>
                                    <template v-slot:[`item.uniqueItemId`]="{ item }">
                                        {{ item.uniqueItemId }}
                                    </template>
                                    <template v-slot:[`item.balance`]="{ item }">
                                        <v-row>
                                            <v-col>{{ $near.utils.format.formatNearAmount(item.balance, 5) }}<sup class="ml-1">(NEAR)</sup></v-col>
                                            <v-col>{{ item.balance }}<sup class="ml-1">(yocto)</sup></v-col>
                                            <v-col>{{ $near.convertToUSD(item.balance) }}<sup class="ml-1">(USD)</sup></v-col>
                                            <v-spacer></v-spacer>
                                        </v-row>
                                    </template>
                                </v-data-table>
                                <v-data-table v-else-if="key === 'itemids_and_msrps'" :headers="headers['itemids_and_msrps']" :items="value.length && value.map(v => ({ itemId: v[0], msrps: v[1] }))" dense>
                                    <template v-slot:[`item.itemId`]="{ item }">
                                        {{ item.itemId }}
                                    </template>
                                    <template v-slot:[`item.msrps`]="{ item }">
                                        <v-select read-only persistent-hint :items="item.msrps" :hint="`prices: ${item.msrps.length}`" :value="item.msrps[0]">
                                            <template v-slot:prepend>
                                                <div style="width: 200px" class="d-flex align-center text-no-wrap">
                                                    <span class="font-weight-light mr-2">average</span>
                                                    {{ $near.utils.format.formatNearAmount(average(item.msrps), 5) }}<sup class="ml-1">(NEAR)</sup>
                                                    {{ $near.convertToUSD($near.utils.format.formatNearAmount(average(item.msrps))) }}<sup class="ml-1">(USD)</sup>
                                                </div>
                                            </template>
                                            <template v-slot:item="{ item: msrp }">
                                                <v-row>
                                                    <v-col>{{ $near.utils.format.formatNearAmount(msrp, 5) }}<sup class="ml-1">(NEAR)</sup></v-col>
                                                    <v-col>{{ msrp }}<sup class="ml-1">(yocto)</sup></v-col>
                                                    <v-col>{{ $near.convertToUSD($near.utils.format.formatNearAmount(msrp)) }}<sup class="ml-1">(USD)</sup></v-col>
                                                    <v-spacer></v-spacer>
                                                </v-row>
                                            </template>
                                        </v-select>
                                    </template>
                                </v-data-table>
                                <v-data-table v-else-if="key === 'paid_gifts'" :headers="headers['paid_gifts']" item-key="key" :items="value && value.map(v => ({ key: JSON.stringify(v.id), ...v }))" dense>
                                    <template v-slot:[`item.id`]="{ item }">
                                        {{ item.id }}
                                    </template>
                                    <template v-slot:[`item.amount`]="{ item }">
                                        <v-row>
                                            <v-col>{{ $near.utils.format.formatNearAmount(item.amount, 5) }}<sup class="ml-1">(NEAR)</sup></v-col>
                                            <v-col>{{ item.amount }}<sup class="ml-1">(yocto)</sup></v-col>
                                            <v-col>{{ $near.convertToUSD(item.amount) }}<sup class="ml-1">(USD)</sup></v-col>
                                            <v-spacer></v-spacer>
                                        </v-row>
                                    </template>
                                </v-data-table>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-container>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <bnft-wishlists-admin-wishlist-table :items="wishlists"></bnft-wishlists-admin-wishlist-table>
            </v-col>
        </v-row>
    </v-container>
</template>
<style scoped>
</style>
<script>
import BN from 'bn.js';
import BnftWishlistsAdminWishlistTable from './BnftWishlistsAdminWishlistTable.vue';
import BnftNearWalletButton from './BnftNearWalletButton.vue';

const { VUE_APP_NEAR_WISHLIST_CONTRACT_ID } = process.env;

export default {
    components: { BnftWishlistsAdminWishlistTable, BnftNearWalletButton },
    name: 'BnftWishlistsAdmin',
    methods: {
        async get(options = { forceUpdate: false }) {
            const { forceUpdate } = options;
            const self = this;
            if (!self.wishlistDataCounts || forceUpdate) {
                self.forcedUpdate = 1;
                self.wishlistDataCounts = await self.$near.wishlist({
                    functionName: 'storage_all_count',
                    depositAmount: 1,
                });
            }
            if (
                (!self.wishlistData &&
                    self?.wishlistDataCounts?.wishlist_ids?.length) ||
                self.forcedUpdate < 2
            ) {
                self.forcedUpdate = 2;
                self.$near.wishlist({
                    functionName: 'storage_all_data',
                    depositAmount: 1,
                });
            }
            if (self.wishlistData && self?.wishlistData?.wishlist_ids?.length) {
                self.$backend
                    .sharedWishlists({
                        ids: self.wishlistData.wishlist_ids,
                    })
                    .then((wishlists) => {
                        const combined = self.wishlistData.wishlist_ids.map(
                            (wishlistId) => {
                                const wishlistDB =
                                    wishlists.find(
                                        (wishlistFromDB) =>
                                            wishlistFromDB.id === wishlistId
                                    ) || {};
                                return {
                                    id: wishlistId,
                                    db:
                                        JSON.stringify(wishlistDB) === '{}'
                                            ? false
                                            : true,
                                    ...wishlistDB,
                                };
                            }
                        );
                        self.wishlists = combined;
                    });
            }
        },
        average(msrps) {
            return msrps.reduce(
                (total, cur) => total.add(new BN(cur)),
                new BN(0)
            );
        }
    },
    data: function () {
        return {
            VUE_APP_NEAR_WISHLIST_CONTRACT_ID,
            wallet: undefined,
            wishlists: undefined,
            imageOverlays: {},
            panels: {
                wishlist_givers_per_item: [0],
                wishlist_item_balance_per_item: [0],
                itemids_and_msrps: [0],
                paid_gifts: [0]
            },
            headers: {
                wishlist_givers_per_item: [
                    { text: `uniqueItemId`, value: 'uniqueItemId' },
                    { text: `giver`, value: 'giver' },
                ],
                wishlist_item_balance_per_item: [
                    { text: `uniqueItemId`, value: 'uniqueItemId' },
                    { text: `balance`, value: 'balance' },
                ],
                itemids_and_msrps: [
                    { text: `itemId`, value: 'itemId' },
                    { text: `msrps`, value: 'msrps' },
                ],
                paid_gifts: [
                    { text: `id`, value: 'id' },
                    { text: `amount`, value: 'amount' }
                ]
            },
        };
    },
    computed: {
        forcedUpdate: {
            get: function () {
                return this.$store.state.forcedUpdate;
            },
            set: function (value) {
                this.$store.commit({ type: 'set', forcedUpdate: value });
            },
        },
        wishlistDataCounts: {
            get: function () {
                return this.$store.state.wishlistDataCounts;
            },
            set: function (value) {
                this.$store.commit({ type: 'set', wishlistDataCounts: value });
            },
        },
        wishlistData: {
            get: function () {
                return this.$store.state.wishlistData;
            },
            set: function (value) {
                this.$store.commit({ type: 'set', wishlistData: value });
            },
        },
        giverIds() {
            return this.wishlistData?.giver_ids;
        },
        wishlistIds() {
            return this.wishlistData?.wishlist_ids;
        },
    },
    mounted() {
        const self = this;
        setTimeout(() => (this.flickerTimeout = true), 1500);
        (async () => {
            if (!(self.$near?.wallet && self.wallet.isSignedIn())) return;
            try {
                await Promise.all(
                    self.$route.query.transactionHashes
                        .split()
                        .map(async (transactionHash) => {
                            const accountId =
                                await self.wallet.getAccountId();
                            const txStatus =
                                await self.$near.near.connection.provider.txStatus(
                                    transactionHash,
                                    accountId
                                );
                            if (
                                txStatus.transaction.actions.find(
                                    (action) =>
                                        action.FunctionCall.method_name ===
                                        'storage_all_count'
                                )
                            ) {
                                const counts = JSON.parse(
                                        Buffer.from(
                                            txStatus.status.SuccessValue,
                                            'base64'
                                        )
                                    )
                                // if no change is detected in the count, there's no reason to query the data
                                if (counts === self.wishlistDataCounts) {
                                    self.forcedUpdate = 2
                                }
                                self.$set(
                                    self,
                                    'wishlistDataCounts',
                                    counts
                                );
                            } else if (
                                txStatus.transaction.actions.find(
                                    (action) =>
                                        action.FunctionCall.method_name ===
                                        'storage_all_data'
                                )
                            ) {
                                self.$set(
                                    self,
                                    'wishlistData',
                                    JSON.parse(
                                        Buffer.from(
                                            txStatus.status.SuccessValue,
                                            'base64'
                                        )
                                    )
                                );
                            }
                        })
                );
                self.get();
            } catch (error) {
                console.error(error);
                return error;
            }
        })();
    },
};
</script>
